<template>
  <div class="conten">
    <el-alert
      title="创建优惠券时，请注意优惠券开始日期不能小于创建当天，使用条件消费金额必须大于等于优惠金额。1.0版的优惠券，是通过客户证件号码发放的，请在勿填写错误，客户必须注册长安典当行的会员才能使用优惠券。"
      type="warning"
      show-icon
      :closable="false">
    </el-alert>

    <!-- 内容栏 -->
    <div class="cons_heads">
      <span class="cons_h">
        <el-button type="primary" icon="el-icon-s-ticket" index="666" @click="quan('create')"
          >创建代金券</el-button
        >
        <el-button type="primary" icon="el-icon-s-ticket" @click="quan"
          >创建折扣券</el-button
        >
        <el-button type="primary" icon="el-icon-s-ticket" @click="quan"
          >创建邀请券</el-button
        >
        <el-button type="primary" icon="el-icon-s-ticket" @click="quan"
          >老客户转介绍券</el-button
        >
        <el-button type="primary" icon="el-icon-s-ticket" @click="quan('detail')"
          >优惠券领取使用详情</el-button
        >
      </span>

      <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="20%">
        <span>该类型的券正在开发中</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="cin_btton">
       <router-view/>
    </div>
   
  </div>
</template>
<script>
export default {
  name: "coupons",
  data() {
    return {
      dialogVisible: false,

    };
  },

  components:{
  },

  methods: {

    quan(e) {
      if(e == 'create' || e == 'detail'){
     return this.$router.push({
        name:e
      })
      }

      this.dialogVisible = !this.dialogVisible;
      
    },

    
  },
  created() {
    
  },
  mounted() {},
};
</script>
<style scoped>

.cons_heads {
  width: 100%;
  height: 80px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.cons_h {
  width: 80%;
}

</style>
